/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation, matchPath } from "react-router-dom";

import HubHeader from '../components/header';
import HubFooter from "../components/footer";
// import GuestTopHeader from "src/components/guestTopHeader";
import TawkToMessengerComp from "src/components/tawk.to";

import { AuthContext } from "../context/authContext";
import { AuthenticatedRoutes, AuthenticatedRoutesWithEoB, ManufacturerRoutes, ManufacturerRoutesWithOutEOB, PublicRoutes } from "../routes/AppRoutes";
import { AppRoute } from "src/routes/types";
import { getReportsByRole, MANUFACTURER_ROUTES_BY_REF_TYPE, redirectPath, USER_TYPES } from "../constants";
import CoPayModal from "src/components/modals/copayModal";
import CaseProvider from "src/context/caseContext";
import { isRouteAllowed, isZilrettaUser } from "src/helpers";


const WithHeaderandFooter: FC<{ WrappedComponent: FC }> = ({ WrappedComponent }): JSX.Element => {
  const [mountTawk, updateMount] = useState(false);
  const [showBanner, setShowBanner] = useState(true)
  const [showCoPayModal, updateVisibilityOfCopay] = useState<boolean>(false)

  const { isUserAuthorized, isManufacturer, isRestoreCalled, userData, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const isSingleSignOn = localStorage.getItem("fromSingleSignOn")


  const navigateToTargetedRoute = (RouteListing: AppRoute[]) => {
    const indexRoute = RouteListing.find((route) => route.isIndex);
    const currentRoute = RouteListing.find((route) =>
      matchPath({ path: route.route, end: false }, pathname)
    );

    // const currentRoute = RouteListing.find((route) => {
    //   // const firstCheck = route.route.includes(pathname);
    //   // if (route.route.includes(":")) {
    //   //   const checkForRoute = route.route.replace(/:([a-z]+)\/?/gi, "/").replace(/\//g, "");
    //   //   const checkForPathname = pathname.replace(/[0-9]/g, "").replace(/\//g, "");
    //   //   const secondCheck = checkForRoute === checkForPathname;
    //   //   return firstCheck || secondCheck;
    //   // } else {
    //   //   return firstCheck;
    //   // }
    //       matchPath({ path: route.route, end: false }, pathname)

    // });

    if (indexRoute && userData) {
      if (currentRoute) {
        if (currentRoute.route.includes("/documents/new")) {
          navigate(redirectPath(userData))
        } else if (userData.ref_type === "rep") {
          if (pathname.includes('reports')) {
            const reports = getReportsByRole(userData)
            const foundReport = reports.find((report: any) => report.redirectLink === pathname);
            if (!foundReport && reports.length > 0) {
              navigate(reports[0].redirectLink + search, { replace: true });
            } else {
              navigate(pathname + search)
            }
          } else if (isRouteAllowed(currentRoute.route, MANUFACTURER_ROUTES_BY_REF_TYPE.REP)) {
            navigate(pathname + search)
          } else {
            navigate(redirectPath(userData));
          }
        } else if (userData.ref_type === "regional_manager") {
          if (isRouteAllowed(currentRoute.route, MANUFACTURER_ROUTES_BY_REF_TYPE.REGIONAL_MANAGER)) {
            navigate(pathname + search)
          } else {
            navigate(redirectPath(userData));
          }
        } else if (userData.ref_type === "district_manager") {
          if (isRouteAllowed(currentRoute.route, MANUFACTURER_ROUTES_BY_REF_TYPE.DISTRICT_MANAGER)) {
            navigate(pathname + search)
          } else {
            navigate(redirectPath(userData));
          }
        } else {
          if (pathname.includes('reports')) {
            let reports = getReportsByRole(userData)
            console.log("Reports....", reports)
            const foundReport = reports.find((report: any) => report.redirectLink === pathname);
            if (!foundReport && reports.length > 0) {
              // agar nahi mila to pehli report par redirect
              navigate(reports[0].redirectLink + search, { replace: true });
            }else{
              console.log("pathname....Search", pathname,search)
               navigate(pathname + search);
            }
            //check karna ha keah ref user main woah reports ha agar ha to dikhani ha warna bydefault first waitForDebuggerli dekhani ha
          } else {
              console.log("pathname....", pathname)

            navigate(pathname + search);
          }

        }
      } else {
        navigate(indexRoute.route);
      }
    }
  };

  const checkForAuthentication = () => {
    if (!isUserAuthorized) {
      navigateToTargetedRoute(PublicRoutes);
    } else {
      if (isSingleSignOn) {
        if (isManufacturer) {
          navigateToTargetedRoute((userData?.eob_button || userData?.ref_type === "fam_rm" || userData?.ref_type === "fam_am") ? ManufacturerRoutes : ManufacturerRoutesWithOutEOB);
        } else {
          navigateToTargetedRoute(userData && userData.eob_button ? AuthenticatedRoutesWithEoB : AuthenticatedRoutes);
        }
      } else {
        if (userData?.is_password_changed === false) {
          navigate("/users/createuser");
        } else if (isManufacturer) {
          navigateToTargetedRoute((userData?.eob_button || userData?.ref_type === "fam_rm" || userData?.ref_type === "fam_am") ? ManufacturerRoutes : ManufacturerRoutesWithOutEOB);
        } else {
          navigateToTargetedRoute(userData && userData.eob_button ? AuthenticatedRoutesWithEoB : AuthenticatedRoutes);
        }
      }
    }
  }

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      navigate(pathname + search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized, isRestoreCalled]);

  useEffect(() => {
    if (isUserAuthorized && userData && !USER_TYPES.MANUFACTURER.includes(userData.ref_type)) updateMount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);


  const handleCloseBanner = () => {
    setShowBanner(false); // will reset on refresh or revisit
  };


  return (
    <>
      <header className="sticky-top shadow-sm"><HubHeader /></header>
      {showBanner && !isManufacturer && isUserAuthorized && (
        <div className="newUpdate-alerts">
          <div className="alert bg-zilretta-copay py-2 m-0 rounded-0">
            <div className="container-fluid">
              <button type="button" className="btn bi bi-x-lg fs-5 p-0 float-end" onClick={handleCloseBanner}></button>
              <h6 className="mb-1 fw-semibold">New ZILRETTA Copay Program Now Available! on FlexForward!</h6>
              <p className="m-0">
                FlexForward is pleased to offer the <b>ZILRETTA Co-Pay Program!</b>
                &nbsp;Eligible patients pay as little as <b>$0</b> for ZILRETTA. <b>($1,000 max per calendar year)</b>.
                For more details on the ZILRETTA Co-Pay program including eligibility requirements and
                enrollment/claim filing process
                <a className="ms-2 text-white" href="." onClick={(e) => {
                  e.preventDefault(); updateVisibilityOfCopay(true);
                }}>
                  click here.
                </a>
              </p>
            </div>
          </div>
          {userData && !isZilrettaUser(userData) ? (
            <div className="alert bg-iovera py-2 m-0 rounded-0">
              <div className="container-fluid">
                <h6 className="mb-1 fw-semibold">
                  FlexForward services for iovera now available for all sites of care
                </h6>
                <p className="m-0">
                  iovera users can easily track their referring & treating providers/facilities all in one place
                  on the FlexForward portal.  When submitting a new request for iovera, Step 2 has been updated
                  so you can enter the sites of care for your patient. Questions? Click the live chat button
                  now or speak to an agent by calling FlexForward at 1-844-353-9466.
                </p>
              </div>
            </div>
          ) : null}
        </div>
      )}

      {pathname === "/cases/new" || pathname.includes("clone") ? (
        <CaseProvider>
          <WrappedComponent />
        </CaseProvider>
      ) :
        <WrappedComponent />
      }
      {mountTawk ? <TawkToMessengerComp /> : null}
      <HubFooter />
      <CoPayModal showModal={showCoPayModal} hideModal={() => updateVisibilityOfCopay(false)} />
    </>
  );
}


export default WithHeaderandFooter;
